module.exports = "/_next/static/images/pattern-green-3c95133dd996b24f6319d1588b6c5721.png";